/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { VAuction, VAuctionInterface } from "../VAuction";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "biddingTime",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_nft",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "provider",
        type: "address",
      },
      {
        internalType: "address",
        name: "vpToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "vpBlock",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_inviteId",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AuctionAlreadyEnded",
    type: "error",
  },
  {
    inputs: [],
    name: "AuctionEndAlreadyCalled",
    type: "error",
  },
  {
    inputs: [],
    name: "AuctionNotYetEnded",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minBid",
        type: "uint256",
      },
    ],
    name: "BidIncreaseNotHighEnough",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "highestBid",
        type: "uint256",
      },
    ],
    name: "BidNotHighEnough",
    type: "error",
  },
  {
    inputs: [],
    name: "UnableToBid",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "winner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "AuctionEnded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "bidder",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "HighestBidIncreased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "MIN_INCREASE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "auctionEnd",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "auctionEndTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "beneficiary",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "bid",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "ended",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "getState",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "highestBid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "highestBidder",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "inviteId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nft",
    outputs: [
      {
        internalType: "contract IERC1155",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pendingReturns",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "provider",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "vpBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vpToken",
    outputs: [
      {
        internalType: "contract IVPToken",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class VAuction__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    biddingTime: BigNumberish,
    _nft: string,
    _tokenId: BigNumberish,
    provider: string,
    vpToken: string,
    vpBlock: BigNumberish,
    _inviteId: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<VAuction> {
    return super.deploy(
      biddingTime,
      _nft,
      _tokenId,
      provider,
      vpToken,
      vpBlock,
      _inviteId,
      overrides || {}
    ) as Promise<VAuction>;
  }
  getDeployTransaction(
    biddingTime: BigNumberish,
    _nft: string,
    _tokenId: BigNumberish,
    provider: string,
    vpToken: string,
    vpBlock: BigNumberish,
    _inviteId: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      biddingTime,
      _nft,
      _tokenId,
      provider,
      vpToken,
      vpBlock,
      _inviteId,
      overrides || {}
    );
  }
  attach(address: string): VAuction {
    return super.attach(address) as VAuction;
  }
  connect(signer: Signer): VAuction__factory {
    return super.connect(signer) as VAuction__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): VAuctionInterface {
    return new utils.Interface(_abi) as VAuctionInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): VAuction {
    return new Contract(address, _abi, signerOrProvider) as VAuction;
  }
}
